import type { ResourceLinkType } from './ResourceLinkEditor';

const SLACK_PATTERN =
  /^https:\/\/arrive\.enterprise\.slack\.com\/archives\/([A-Z0-9]+)(?:[/?#].*)?$/i;
const CORPORATE_DOMAINS = ['jira.com', 'atlassian.net', 'confluence.com'];
const JIRA_BROWSE_PATTERN = /\/browse\/([A-Z][A-Z0-9]*)-\d+/i;
const CONFLUENCE_SPACE_PATTERN = /\/wiki\/spaces\/([A-Za-z0-9_~-]+)/i;

export function validateUrl(type: ResourceLinkType, url: string): string | undefined {
  if (!url) return undefined;
  if (type === 'slack') {
    if (!SLACK_PATTERN.exec(url)) {
      return 'Slack URL must match: https://arrive.enterprise.slack.com/archives/[CHANNEL_ID]';
    }
    return undefined;
  }
  try {
    const parsed = new URL(url);
    if (!['http:', 'https:'].includes(parsed.protocol)) {
      return 'URL must use http or https';
    }
    if (
      (type === 'jira' || type === 'confluence') &&
      !CORPORATE_DOMAINS.some(d => parsed.hostname === d || parsed.hostname.endsWith(`.${d}`))
    ) {
      return `Consider using a corporate domain (e.g. your-org.atlassian.net)`;
    }
  } catch {
    return 'Not a valid URL';
  }
  return undefined;
}

/**
 * Extracts the Jira project key, Confluence space key, or Slack channel ID
 * from a URL. Returns undefined if the URL doesn't match the expected
 * structure.
 */
export function extractSlug(type: ResourceLinkType, url: string): string | undefined {
  if (type === 'jira') {
    return JIRA_BROWSE_PATTERN.exec(url)?.[1]?.toUpperCase();
  }
  if (type === 'confluence') {
    return CONFLUENCE_SPACE_PATTERN.exec(url)?.[1];
  }
  if (type === 'slack') {
    return SLACK_PATTERN.exec(url)?.[1]?.toUpperCase();
  }
  return undefined;
}
